exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dish-group-manage-container[data-v-7ee9f92a]{padding:16px}.radio-group-container[data-v-7ee9f92a]{margin-top:0;margin-bottom:16px}.component-container[data-v-7ee9f92a]{width:100%}", ""]);

// exports
